import "../../style.css";
import React from "react";
import TextareaContainer from "./components/TextareaContainer";
import Canvas from "../../components/Canvas/Canvas";
import ExportButton from "../../components/Buttons/ExportButton";
import ChatbotButton from "../../components/Buttons/ChatbotButton";
import SettingsButton from "../../components/Buttons/SettingsButton";
import CheckersButton from "../../components/Buttons/CheckersButton";
import Splitter from "../../components/Splitter/Splitter";

const DirectRenderPage = () => {

  return (
    <Splitter>
      <TextareaContainer />
      <Canvas>
        <ExportButton variant="circle" />
        <CheckersButton />
        <ChatbotButton />
        <SettingsButton />
      </Canvas>
    </Splitter>
  );
};

export default DirectRenderPage;